export interface HeaderNavigationItem {
  title: string
  href: string
  isEmbeddedAppLink: boolean
}

export const accountLinks: Record<'relish' | 'guest', HeaderNavigationItem[]> = {
  relish: [
    {
      title: 'My account',
      href: '/profile&source=marketing-site',
      isEmbeddedAppLink: true
    },
    {
      title: 'Coupons',
      href: '/relish&source=marketing-site',
      isEmbeddedAppLink: true
    }
  ],
  guest: [
    {
      title: 'Sign in',
      href: '/sign-in&source=marketing-site&journeyType=marketing_site_nav_button',
      isEmbeddedAppLink: true
    },
    {
      title: 'Join relish',
      href: '/sign-up&source=marketing-site&journeyType=marketing_site_nav_button',
      isEmbeddedAppLink: true
    }
  ]
}
